<i18n>
{
  "en": {
    "welcome": "Welcome to <b class='font-weight-light'>CADDIE</b>",
    "subtitle": "<big>C</big>ompetency-based <big>A</big>nalysis, <big>D</big>esign, <big>D</big>evelopment, <big>I</big>mplementation, and <big>E</big>valuation",
    "copyright": "Copyright &copy; 2019 <a href='https://www.geistt.com' target='_blank'>GEISTT AB</a>. All rights reserved."
  },
  "sv": {
    "welcome": "Välkommen till <b class='font-weight-normal'>CADDIE</b>",
    "subtitle": "<big>C</big>ompetency-based <big>A</big>nalysis, <big>D</big>esign, <big>D</big>evelopment, <big>I</big>mplementation, and <big>E</big>valuation",
    "copyright": "Copyright &copy; <a href='https://www.geistt.com' target='_blank'>GEISTT AB</a> 2019"
  }
}
</i18n>

<template>
  <v-layout
    text-xs-center
    wrap
  >
    <v-flex mb-3>
      <h1 class="display-3 font-weight-light grey--text" v-html="$t('welcome')"></h1>
      <p class="welcome-subtitle font-weight-light grey--text">
        <span v-html="$t('subtitle')"></span><br>
      </p>
      <p class="welcome-copyright font-weight-light grey--text text--lighten-1">
        <span v-html="$t('copyright')"></span>
      </p>
    </v-flex>
  </v-layout>
</template>

<style>
  .welcome-subtitle {
    text-transform: uppercase;
  }
  .welcome-subtitle {
    font-size: 13px;
    margin-bottom: 0;
  }
  .welcome-subtitle big {
    font-size: 18px;
    font-weight: 400;
  }
  .welcome-copyright a {
    color: #bbb;
  }
</style>

<script>
  export default {
    data: () => ({
    })
  }
</script>

